import React, { useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { getConfig } from '../../../utils/config';

export const Overlay = ({ visible, onClick }) => {
    return (
        <div
            onClick={onClick}
            className={
                'fixed z-30 inset-0   overflow-y-auto h-full w-[10%]' +
                (visible ? ' block' : ' hidden')
            }
            id="my-modal"
        ></div>
    );
};
const CartSidebar = ({
    className,
    visible,
    onClick,
    children,
    onlyMobile,
    survey
}) => {
    const config = getConfig();
    useEffect(() => {
        const parentElement = document.getElementById('root'); // Target the root div or change to the correct parent container
        if (parentElement) {
            if (visible) {
                parentElement.classList.add('mod-open');
            } else {
                parentElement.classList.remove('mod-open');
            }
        }
        // Cleanup on unmount
        return () => {
            if (parentElement) {
                parentElement.classList.remove('mod-open');
            }
        };
    }, [visible]);
    return ReactDom.createPortal(
        <>
            <Overlay visible={visible} onClick={onClick} />
            {visible && (
                <div
                    className={` fixed h-screen  right-0 w-full lg:w-[8%] cart_modalSection  border-l border-gray-300 ${
                        survey === true ? 'lg:top-[60%] top-[48%] ' : ''
                    }  bottom-0 ${
                        onlyMobile ? 'lg:hidden' : ''
                    }$   ml-auto   z-40 "`}
                >
                    <div
                        className={` ${
                            className ? '' : 'py-4'
                        } bg-white shadow-sm h-full rounded-t-2xl ${
                            survey === true ? 'lg:rounded-t-2xl' : ''
                        }   lg:rounded-none`}
                    >
                        {children}
                    </div>
                </div>
            )}
        </>,
        document.getElementById('sideBar')
    );
};

export default CartSidebar;
